export const COLORS = {
  main: '#f17680',
  light: '#f8b18e',
  dark: '#c06c86',
  white: '#ffffff',
  mainSecondary: '#555555',
  lightSecondary: '#cccccc',
  darkSecondary: '#555555',
};
